export default __webpack_public_path__ + "static/1228-d76c995bd30da8a5cd2bb1e310c324ff.gif";